import { render, staticRenderFns } from "./SISStudentContacts.vue?vue&type=template&id=277f3a8c&"
import script from "./SISStudentContacts.vue?vue&type=script&lang=js&"
export * from "./SISStudentContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../CommunityWebPortal/_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('277f3a8c')) {
      api.createRecord('277f3a8c', component.options)
    } else {
      api.reload('277f3a8c', component.options)
    }
    module.hot.accept("./SISStudentContacts.vue?vue&type=template&id=277f3a8c&", function () {
      api.rerender('277f3a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueCommon/common-components/src/components/Widgets/SISStudentContacts.vue"
export default component.exports